import React, { useEffect, useState } from "react";
import { images } from "../../assets/images";
import InputWithIcon from "../../components/FormFields/InputWithIcon/index";
import { icons } from "../../assets/icons";
import Checkbox from "../../components/FormFields/Checkbox";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { toast } from "react-toastify";
import { deleteCookie, getCookie, setCookie } from "../../utils/helpers";

const Login = () => {
  const { login, user } = useAuth();
  const [username, setUsername] = useState("");
  const [hidePass, setHidePass] = useState(true);
  const [password, setPassword] = useState("");
  // const [rememberMe, setRememberMe] = useState(false);

  // useEffect(() => {
  //   const storedUsername = getCookie("username1");
  //   const storedPassword = getCookie("password1");
  //   if (rememberMe && storedUsername && storedPassword) {
  //     setUsername(storedUsername);
  //     setPassword(storedPassword);
  //   }
  // }, [rememberMe]);

  const navigate = useNavigate();

  const onClickLogin = async () => {
    if (!username || !password) {
      toast.error("Please enter username and password");
      return;
    }
    // if (rememberMe) {

    //   setCookie("username1", username, 30); // Store username cookie for 30 days
    //   setCookie("password1", password, 30); // Store password cookie for 30 days
    // } else {
    //   deleteCookie("username1");
    //   deleteCookie("password1");
    // }
    await login(username, password);
  };

  if (user?.access_token) {
    return <Navigate to="/" />;
  }

  return (
    <div
      className="login-container"
      style={{
        background: `url(${images.loginBackground}) no-repeat center center/cover`,
      }}
    >
      <div className="login-form-container">
        <img
          src={images.mainLogo}
          className="main-logo"
          alt="keventer's logo"
        />
        {/* <div className='font-size-medium text-center mt-[-1.6rem] font-[500] font-["Fraunces"]'>
          KICS - Keventers Internal Communication System
        </div> */}
        <div className="login-form flex flex-col justify-center">
          <div className="font-family-medium font-size-large mb-6">
            Please login to your account
          </div>
          <InputWithIcon
            leftIcon={icons.userIcon}
            placeholder="Enter your username"
            containerClassName="mb-4"
            wrapperClassName="w-[100%]"
            onChange={(text) => setUsername(text)}
            autoComplete={"username"}
          />
          <InputWithIcon
            leftIcon={icons.passwordIcon}
            rightIcon={!hidePass ? icons.openEye : icons.closeEye}
            rightIconHandler={() => {
              setHidePass((prev) => !prev);
            }}
            rightIconStyle={{ top: "14px", right: "13px", cursor: "pointer" }}
            placeholder="Password"
            wrapperClassName="w-[100%]"
            onChange={(text) => setPassword(text)}
            autoComplete={hidePass ? "password" : "text"}
            type={hidePass ? "password" : "text"}
            submitEvent={(event) => {
              if (event.key === "Enter" || event.charCode === 13) {
                onClickLogin();
              }
            }}
          />
          <div className="remember-forgot-container flex justify-end mt-6 w-[100%]">
            {/* <Checkbox
            title="Remember Me"
            checked={rememberMe}
            onChange={(isChecked) => setRememberMe(isChecked)}
          />             */}
            <div
              className="font-size-small text-[var(--appColor)] cursor-pointer"
              onClick={() => navigate("/forgetPassword")}
            >
              Forget Password?
            </div>
          </div>
          <button
            className="login-button font-family-bold font-size-large !h-[5.8rem]"
            onClick={onClickLogin}
            type="button"
          >
            Login
          </button>
          <div className="font-size-small text-[var(--ultraLightGray)] mt-6 m-auto">
            &copy; Powered by CorePeelers
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
